import { render, staticRenderFns } from "./SubcategoriesTable.vue?vue&type=template&id=0936a244&"
import script from "./SubcategoriesTable.vue?vue&type=script&lang=js&"
export * from "./SubcategoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./SubcategoriesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports